module.exports = __webpack_public_path__ + "img/layout.3ea65931.png";